import { graphql } from '@contra/relay';

export const adminSignInUrl = graphql`
  mutation AdminSignInUrlMutation($input: AdminCreateSignInUrlInput!) {
    adminCreateSignInUrl(input: $input) {
      errors {
        message
      }
      signInUrl
    }
  }
`;
